module.exports = __webpack_public_path__ + "static/media/play-button.236159c2.png";